export default __webpack_public_path__ + "img/all_reaction.7e399cca.jpg";